const comm = {

    /**
     * 生成32位UUID
     */
    newGuid() {
        var guid = "";
        for (var i = 1; i <= 32; i++) {
            var n = Math.floor(Math.random() * 16.0).toString(16);
            guid += n;
        }
        return guid;
    },

    /**
     * 高度
     */
     difHeightFun(vals){
        let heights = null;
        let difHeight = localStorage.getItem('difHeight');
        let curHeight;
        if(document.querySelector(".innerBg")){
            curHeight = document.querySelector(".innerBg").offsetHeight;
        }else{
            curHeight = 0;
        }

        let dif = Number(difHeight) - Number(curHeight);
        if(vals <= dif){
            heights = dif+'px';
        }else{
            heights = "auto";
        }
        return heights;
    },
    // 获取当前日期 
    getCurrentDate() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },

    getNavIndexByChannelId(channelId) {
        const channelMap = {
            '53': 1, '15': 2, '8': 3, '9': 4, '11': 5, '7': 6, '12': 7,
            'd8': 8, 'd9': 9, 'd10': 10
        };
        return channelMap[channelId] || 2; // 默认最新新闻
    },
    // 根据栏目类型获取对应的路由路径
    getRoutePathByColumnType(columnType) {
        const routeMap = {
            1: '/newsPage',        // 新闻
            2: '/merchantView',    // 商家
            3: '/recruitmentIndex', // 招聘
            4: '/easyBookView'     // 易书
        };
        return routeMap[columnType] || '/newsPage'; // 默认新闻页面
    },
    navigateToArticle(data, routerInstance) {
        let indexs = null, channelIds = null, path = '';
        const channelMap = {
            '53': 1, '15': 2, '8': 3, '9': 4, '11': 5, '7': 6, '12': 7,
            'd8': 8, 'd9': 9, 'd10': 10
        };
        const columnType = data.newsInfo.columnType;
        const columnPath = data.newsInfo.columnPath;
        if (columnType == 2) {
            indexs = 8;
            channelIds = 'd8';
            path = '/merchantView';
        } else if (columnType == 3) {
            indexs = 9;
            channelIds = 'd9';
            path = '/recruitmentIndex';
        } else if (columnType == 4) {
            indexs = 10;
            channelIds = 'd10';
            path = '/easyBookView';
        } else {
            indexs = channelMap[columnPath];
            // indexs = channelMap[columnPath] || 0;
            channelIds = columnPath;
            path = '/newsPage';
        }
        routerInstance.push({
            path: path,
            query: {
                newsCode: data.newsCode, 
                channelId: channelIds,
                index: indexs
            }
        });
    },
}
export default comm


// WEBPACK FOOTER //
// ./src/utils/comm.js